export default __webpack_public_path__ + "static/media/backgroundBOS.2a9a0d59.png";